export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 439c34.667-114.182 140.667-192.328 318-234.438C495.333 162.452 610 75.931 662-1h130v440H0z\" fill=\"#EBF5FB\"/>",
  "attrs": {
    "width": "678",
    "height": "439",
    "viewBox": "0 0 678 439",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};